import { TransactionActivity } from "@models/clients/clients.details/transactionActivity";


export class AddTransactionActivityModalController {
    public client: any;
    public transactionActivity: Partial<TransactionActivity> = {};
    public dropdownOptions: any = {};
    public isEditMode: boolean = false;
    public isLoading: boolean = false;
    public title: string = 'New Transaction Activity';
    public clientPortfolioAccounts: any[] = [];

    /** @ngInject */
    constructor(
        private $mdDialog: angular.material.IDialogService
    ) {}

    public $onInit(): void {
        // Load all type options from the service        
        // Check if we're in edit mode
        this.isEditMode = this.transactionActivity && this.transactionActivity.id ? true : false;
        
        if (this.isEditMode) {
            this.title = 'Edit Transaction Activity';
        } else {
            // Initialize with default values for new transaction activity
            this.transactionActivity = {
                name: '',
                transactionType: undefined,
                bank: 4,
                currency: 7,
                portfolioAccount: '',
            } as Partial<TransactionActivity>;
        }
    }

    public onTransactionTypeChange(): void {
        // Clear conditional fields when transaction type changes
        this.clearConditionalFields();
    }

    private clearConditionalFields(): void {
        // Clear standing order fields
        this.transactionActivity.standingOrder = undefined;
        this.transactionActivity.standingOrderAmount = undefined;
        this.transactionActivity.standingOrderStartDate = undefined;
        this.transactionActivity.standingOrderEndDate = undefined;
        this.transactionActivity.standingOrderFrequency = undefined;
        this.transactionActivity.standingOrderDebitAccountNumber = undefined;
        this.transactionActivity.standingOrderCreditAccountNumber = undefined;

        // Clear life project fields
        this.transactionActivity.lifeProject = undefined;
        this.transactionActivity.lifeProjectAmount = undefined;
        this.transactionActivity.lifeProjectStartDate = undefined;
        this.transactionActivity.lifeProjectEndDate = undefined;
        this.transactionActivity.numberOfTranches = undefined;
        this.transactionActivity.lifeProjectDebitAccountNumber = undefined;

        // Clear loan repayment fields
        this.transactionActivity.loan = undefined;
        this.transactionActivity.loanAmount = undefined;
        this.transactionActivity.capitalRepaymentAmount = undefined;
        this.transactionActivity.frequencyOfLoanRepayment = undefined;
        this.transactionActivity.frequencyAmount = undefined;
        this.transactionActivity.nextCapitalRepaymentDate = undefined;
        this.transactionActivity.capitalAmountRepaid = undefined;
        this.transactionActivity.loanDebitAccountNumber = undefined;
        this.transactionActivity.loanCreditAccountNumber = undefined;
        this.transactionActivity.currencyOfInterestRepaymentAmount = undefined;
        this.transactionActivity.frequencyOfInterestRepayment = undefined;
        this.transactionActivity.interestPaymentDate = undefined;

        // Clear pledge fields
        this.transactionActivity.pledge = undefined;
        this.transactionActivity.pledgeAmount = undefined;
        this.transactionActivity.pledgeStartDate = undefined;
        this.transactionActivity.pledgeEndDate = undefined;

        // Clear overdraft facility fields
        this.transactionActivity.overdraftFacility = undefined;
        this.transactionActivity.overdraftFacilityAmount = undefined;
        this.transactionActivity.overdraftFacilityStartDate = undefined;
        this.transactionActivity.overdraftFacilityEndDate = undefined;

        // Clear fiduciary deposit fields
        this.transactionActivity.fiduciaryDeposit = undefined;
        this.transactionActivity.fiduciaryDepositAmount = undefined;
        this.transactionActivity.fiduciaryDepositStartDate = undefined;
        this.transactionActivity.fiduciaryDepositEndDate = undefined;

        // Clear lombard credit facility fields
        this.transactionActivity.lombardCreditFacility = undefined;
        this.transactionActivity.lombardCreditFacilityAmount = undefined;
        this.transactionActivity.lombardCreditFacilityStartDate = undefined;
        this.transactionActivity.lombardCreditFacilityEndDate = undefined;
    }

    public showStandingOrderFields(): boolean {
        // Show standing order fields based on transaction type
        // These are placeholder IDs - you'll need to map them to actual transaction type IDs from your system
        return this.transactionActivity.transactionType === 1; // Standing Order
    }

    public showLifeProjectFields(): boolean {
        // Show life project fields based on transaction type
        return this.transactionActivity.transactionType === 2; // Life Project
    }

    public showLoanRepaymentFields(): boolean {
        // Show loan repayment fields based on transaction type
        return this.transactionActivity.transactionType === 3; // Loan Repayment
    }

    public showPledgeFields(): boolean {
        // Show pledge fields based on transaction type
        return this.transactionActivity.transactionType === 4; // Pledge
    }

    public showOverdraftFacilityFields(): boolean {
        // Show overdraft facility fields based on transaction type
        return this.transactionActivity.transactionType === 5; // Overdraft Facility
    }

    public showFiduciaryDepositFields(): boolean {
        // Show fiduciary deposit fields based on transaction type
        return this.transactionActivity.transactionType === 6; // Fiduciary Deposit
    }

    public showLombardCreditFacilityFields(): boolean {
        // Show lombard credit facility fields based on transaction type
        return this.transactionActivity.transactionType === 7; // Lombard Credit Facility
    }

    public getTransactionTypeName(): string {
        if (!this.transactionActivity.transactionType || !this.dropdownOptions.transactionactivitytype) {
            return '';
        }
        
        const selectedType = this.dropdownOptions.transactionactivitytype.find(
            (option: any) => option.id === this.transactionActivity.transactionType
        );
        
        return selectedType ? selectedType.displayName : '';
    }

    public save(): void {
        // Validate required fields
        if (!this.transactionActivity.name) {
            // Show error message
            console.log('Error: Transaction activity name is required');
            return;
        }
        this.$mdDialog.hide(this.transactionActivity);
    }

    public cancel(): void {
        this.$mdDialog.cancel();
    }
}

export const AddTransactionActivityModalComponent: angular.IComponentOptions = {
    template: require('./add-transaction-activity-modal.html'),
    controller: AddTransactionActivityModalController,
    controllerAs: '$ctrl',
    bindings: {
        client: '<',
        transactionActivity: '=',
        dropdownOptions: '<',
        clientPortfolioAccounts: '<'
    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/banking-activities/modals/add-transaction-activity-modal.ts